import { Component, Output, Input, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { navigation } from '../../../app-navigation';

interface NavItem {
  text: string;
  path: string;
  icon?: string;
}

@Component({
    selector: 'app-side-navigation-menu',
    templateUrl: './side-navigation-menu.component.html',
    styleUrls: ['./side-navigation-menu.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideNavigationMenuComponent {

  @Output() readonly selectedItemChanged = new EventEmitter<NavItem>();

  @Output() readonly openMenu = new EventEmitter<void>();

  @Input() compactMode = false;

  @Input() selectedItem: string | String = '';

  private readonly iconMap: Record<string, string> = {
    'dashboard': 'fa-solid fa-gauge-high',
    'statement-center': 'fa-solid fa-file-lines',
    'shield': 'fa-solid fa-shield-halved',
    'link': 'fa-solid fa-link',
    'upload': 'fa-solid fa-upload',
    'email': 'fa-solid fa-envelope',
  };

  readonly navItems: NavItem[] = navigation
    .filter((item): item is { text: string; path: string; icon: string } => 'path' in item && 'text' in item)
    .map(item => ({
      text: item.text,
      path: item.path.startsWith('/') ? item.path : `/${item.path}`,
      icon: item.icon
    }));

  getIconClass(icon: string): string {
    return this.iconMap[icon] || `fa-solid fa-${icon}`;
  }

  onItemClick(event: Event, item: NavItem) {
    if (this.compactMode) {
      this.openMenu.emit();
    }
    this.selectedItemChanged.emit(item);
  }
}
